export default __webpack_public_path__ + "static/media/sctv-logo.e9a7b382.png";